module.exports = __webpack_public_path__ + "assets/img/fengmian.6088ca8e.png";